import React from 'react';
import ThankYou from 'components/tailgrids-ui/thank-you';
// import ThankYou from 'components/commercetools-ui/thank-you';

const ThankYouTastic = () => {
  return <ThankYou />;
};

export default ThankYouTastic;
